import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Calendar, MapPin } from "lucide-react";
import { api } from "../../lib/api";

export const Retreats = () => {
  const [retreats, setRetreats] = useState([]);

  useEffect(() => {
    api.get("/retreats").then((r) => setRetreats(r.data.retreats || [])).catch(() => {});
  }, []);

  const r = retreats[0];

  return (
    <section
      id="retreats"
      data-testid="retreats-section"
      className="relative py-24 md:py-32 bg-[#0B2B40] text-white overflow-hidden"
    >
      {r && (
        <>
          <img
            src={r.image}
            alt="Retreat"
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B2B40] via-[#0B2B40]/85 to-[#0B2B40]/40" />
        </>
      )}

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="text-xs tracking-[0.3em] uppercase text-[#E8F0F8] font-medium mb-5">
            First Retreat — In Person · Free RSVP
          </div>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-tight font-light">
            {r ? r.title : "Coastal Stillness Retreat"}
          </h2>
          <p className="mt-6 text-lg md:text-xl text-white/80 font-light max-w-2xl leading-relaxed">
            {r
              ? r.description
              : "A quiet immersion into breath, silence, and inner clarity."}
          </p>

          {r && (
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-5 text-sm">
              <div className="flex items-center gap-3 text-white/85">
                <Calendar size={16} className="text-[#E8F0F8]" />
                <span>{r.month}{r.time ? ` · ${r.time}` : ""}</span>
              </div>
              <div className="flex items-center gap-3 text-white/85">
                <MapPin size={16} className="text-[#E8F0F8]" />
                <span>{r.location}</span>
              </div>
              <div className="flex items-center gap-3 text-white/85">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E8F0F8]" />
                <span>{r.spots}</span>
              </div>
            </div>
          )}

          {r && r.highlights && (
            <ul className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-3 max-w-2xl text-white/85">
              {r.highlights.map((h) => (
                <li key={h} className="flex items-start gap-3 text-[15px]">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#E8F0F8]" />
                  <span>{h}</span>
                </li>
              ))}
            </ul>
          )}

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              data-testid="retreat-cta-button"
              className="bg-white text-[#0B2B40] hover:bg-[#E8F0F8] px-9 py-4 text-sm font-medium tracking-wide transition-colors duration-300 inline-flex items-center justify-center"
            >
              RSVP for This Retreat
            </a>
            <a
              href="#contact"
              className="bg-transparent text-white border border-white/40 hover:bg-white/10 px-9 py-4 text-sm font-medium tracking-wide transition-colors duration-300 inline-flex items-center justify-center"
            >
              Ask a Question
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Retreats;
